import { render, staticRenderFns } from "./MediationSterlingCompare.vue?vue&type=template&id=8bec1c8e&"
import script from "./MediationSterlingCompare.vue?vue&type=script&lang=js&"
export * from "./MediationSterlingCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports